import React from 'react';
import {Badge} from '@albert-io/atomic';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface ArchivedQuestionBadgeProps {
  classname?: string;
}

export const ArchivedQuestionBadge: React.FC<ArchivedQuestionBadgeProps> = ({classname}) => {
  return (
    <Badge
      status='warning'
      icon={['far', 'box-archive'] as IconProp}
      iconAlign='left'
      size='small'
      emphasis='subtle'
      className={`max-w-fit !rounded-x0-half ${classname}`}
    >
      Archived Question
    </Badge>
  );
};

export default ArchivedQuestionBadge;
